import { styled } from '../../themeCustomink';
import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
import { Box } from '../Layout';
var sliderWidth = function (_a) {
    var navigatorSide = _a.navigatorSide, thumbSize = _a.thumbSize, hasThumbs = _a.hasThumbs;
    var thumbPlusGutter = function (thumbSize) {
        var thumbSizeMap = { medium: 56, small: 48 };
        var GUTTER_SIZE = 16;
        return thumbSizeMap[thumbSize] + GUTTER_SIZE;
    };
    if (!hasThumbs || navigatorSide === 'bottom')
        return '100%';
    return "calc(100% - ".concat(thumbPlusGutter(thumbSize), "px)");
};
var getBgRGB = function (color) {
    return color === 'gray' ? designTokens.color.gray.light.value : '#fff';
};
// do not forward props to a DOM element lest you get a verbose react error
var nonForwardableProps = [
    'thumbSize',
    'hasThumbs',
    'sliderHeight',
    'navigatorSide',
    'sliderBg',
];
export var CarouselContainer = styled(Box, {
    name: 'PigmentCarousel',
    shouldForwardProp: function (prop) { return !nonForwardableProps.includes(prop); },
})(function (_a) {
    var thumbSize = _a.thumbSize, hasThumbs = _a.hasThumbs, sliderHeight = _a.sliderHeight, navigatorSide = _a.navigatorSide, sliderBg = _a.sliderBg;
    return ({
        position: 'relative',
        flexDirection: navigatorSide === 'left' ? 'row-reverse' : 'column',
        display: 'flex',
        width: '100%',
        height: 'max-content',
        '.slider': {
            width: sliderWidth({ navigatorSide: navigatorSide, thumbSize: thumbSize, hasThumbs: hasThumbs }),
            height: sliderHeight || '100%',
            position: 'relative',
            backgroundColor: getBgRGB(sliderBg),
            '.keen-slider': {
                height: '100%',
                '*': {
                    height: '100%',
                },
            },
            '.keen-slider__slide': {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            },
            '.arrow-container': {
                position: 'absolute',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                '.arrow': {
                    pointerEvents: 'auto',
                    margin: '0 8px',
                    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.08)',
                    backgroundColor: '#fff',
                    fontSize: designTokens.typography.icon.medium.size.value,
                    width: '32px',
                    height: '32px',
                    zIndex: 1,
                    '&:hover': {
                        backgroundColor: '#f3f3f3',
                    },
                    '&:active': {
                        backgroundColor: designTokens.color.gray.active.original.value,
                    },
                    '&.left svg': {
                        transform: 'scale(-1,1);',
                    },
                    '&.disabled': {
                        backgroundColor: 'transparent',
                        cursor: 'default',
                        boxShadow: 'none',
                    },
                },
            },
        },
        '.dots-container': {
            position: 'absolute',
            display: 'flex',
            justifyContent: 'center',
            padding: '20px 0',
            bottom: 0,
            left: 0,
            right: 0,
            // unfortunately this is needed due to Stylebitz interference; TODO remove when Stylebitz no longer coexists with Pigment in our frontend apps
            boxSizing: 'unset',
        },
        '.thumbnails': {
            display: 'flex',
            gap: 8,
            '&.left': {
                flexDirection: 'column',
                marginRight: 16,
            },
            '&.bottom': {
                marginTop: 16,
                justifyContent: 'center',
            },
            '.thumbnail': {
                display: 'flex',
                position: 'relative',
                justifyContent: 'center',
                boxSizing: 'border-box',
                overflow: 'hidden',
                backgroundColor: '#fff',
                borderRadius: '4px',
                flexShrink: 0,
                cursor: 'pointer',
                '&:before': {
                    borderRadius: '4px',
                    border: "1px solid ".concat(designTokens.color.gray.light.value),
                    transition: 'border .1s ease-out',
                    position: 'absolute',
                    content: '" "',
                    top: 0,
                    bottom: 0,
                    right: 0,
                    left: 0,
                    // fancy blend mode hack to turn non-transparent images with white bg slightly gray
                    mixBlendMode: 'darken',
                    boxShadow: "inset 0px 0px 8px 4px ".concat(designTokens.color.gray.light.value),
                },
                '&:hover:before': {
                    border: "1px solid ".concat(designTokens.color.gray.disabled.value),
                },
                '&.selected:before': {
                    cursor: 'default',
                    border: "1px solid ".concat(designTokens.color.gray.obsidian.value),
                },
                '&.medium': {
                    height: 56,
                    width: 56,
                    '& > *': {
                        width: 56,
                        objectFit: 'contain',
                    },
                },
                '&.small': {
                    height: 48,
                    width: 48,
                    '& > *': {
                        width: 48,
                        objectFit: 'contain',
                    },
                },
            },
        },
    });
});
// Breaking out Dot separately for the convenience of
// conditionally rendering color with SX prop
export var Dot = styled('div', { name: 'PigmentCarousel-Dot' })({
    border: 'none',
    width: designTokens.spacing[8].value,
    height: designTokens.spacing[8].value,
    padding: 4,
    '&:after': {
        content: '""',
        background: '#fff',
        opacity: 0.6,
        width: designTokens.spacing[8].value,
        height: designTokens.spacing[8].value,
        borderRadius: '61px',
    },
    '&:hover': {
        '&:after': {
            opacity: 1,
        },
    },
    cursor: 'pointer',
    display: 'inline-flex',
});
//# sourceMappingURL=CarouselStyles.js.map